import store from '@/stores';
import { screen } from '@/router/screenRoutes';

const beforeEnter = (to, from, next) => {
  const roles = store.state.user.userInfo.roles_ids || [];
  const isInternalUser = Boolean(store.state.user.userInfo.internal_employee);
  const validIds = [1, 6, 11, 15];
  const isValid = !!roles.find((id) => validIds.includes(id));

  if (isValid || isInternalUser) next();
  else next({ name: from.name });
};

export default [
  // routes
  {
    ...screen('accordance'),
    component: () => import('@/views/AccordanceList.vue'),
    beforeEnter,
    props: true,
  },
  {
    ...screen('accordance-edit'),
    component: () => import('@/views/AccordanceEdit.vue'),
    beforeEnter,
    props: true,
  },

  // redirects
  // ...
];
